export default function Hero() {
  return (
    <section id="inicio" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/e86a6f0dbefd24b3e1189eb9e611dc93/5f53091e50566b3a84986dae71c86b56.png"
          alt="Abogados laboralistas en Murcia"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Quereda y Murcia:<br />
          Abogados Laboralistas y Graduados Sociales
        </h1>
        <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed">
          El Derecho del Trabajo busca equilibrar las relaciones laborales, promoviendo la justicia social y la dignidad en el ámbito laboral. <strong className="text-[#A77047]">Quereda Y Murcia</strong> somos laboralistas especializados en <strong>Derecho Laboral, además de Graduados Sociales y Economistas.</strong>
        </p>
      </div>
    </section>
  );
}